export class CallFrequency {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
}

export default CallFrequency;